export default "__VITE_ASSET__CdAbiGu4__"